<template>
  <div id="kdm-simulation-page">
    <div class="vx-row">
      <!-- SOL: Form Alanı -->
      <div class="vx-col w-2/3 pr-4">
        <vs-card>
          <div slot="header"><h3>📝 Aday Başvuru ve Ödeme Bilgileri</h3></div>
          <p class="sim-desc">KDM sistemi üzerinden gelen ödeme verileri. Aşağıdaki adımları sırasıyla takip edin.</p>
          <div class="vx-row">
            <div class="vx-col w-1/2 mb-2">
              <label>Kişi ID</label>
              <vs-input v-model="form.KisiId" class="w-full" :disabled="formLocked" />
            </div>
            <div class="vx-col w-1/2 mb-2">
              <label>TC Kimlik No</label>
              <vs-input v-model="form.KisiTcNo" class="w-full" :disabled="formLocked" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/2 mb-2">
              <label>Ad Soyad</label>
              <vs-input v-model="form.KisiAdSoyad" class="w-full" :disabled="formLocked" />
            </div>
            <div class="vx-col w-1/2 mb-2">
              <label>E-posta</label>
              <vs-input v-model="form.KisiMail" class="w-full" :disabled="formLocked" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/2 mb-2">
              <label>Tutar (KDV Hariç) ₺</label>
              <vs-input v-model.number="form.Tutar" type="number" class="w-full" :disabled="formLocked" />
            </div>
            <div class="vx-col w-1/2 mb-2">
              <label>Hizmet Kodu</label>
              <vs-input v-model="form.HizmetKodu" class="w-full" :disabled="formLocked" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/2 mb-2">
              <label>Application ID</label>
              <vs-input v-model.number="form.ApplicationId" type="number" class="w-full" :disabled="formLocked" />
            </div>
            <div class="vx-col w-1/2 mb-2">
              <label>Adres</label>
              <vs-input v-model="form.KisiAdres" class="w-full" :disabled="formLocked" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <label>Açıklama</label>
              <vs-input v-model="form.Aciklama" class="w-full" :disabled="formLocked" />
            </div>
          </div>
        </vs-card>

        <!-- iFrame Alanı -->
        <vs-card v-if="iframeUrl" class="mt-4">
          <div slot="header"><h3>💳 Ödeme Ekranı (iFrame)</h3></div>
          <div class="sim-iframe-wrapper">
            <div v-if="iframeLoading" class="sim-iframe-loading">
              <div class="spinner"></div>
              <p>Ödeme ekranı yükleniyor...</p>
            </div>
            <iframe
              :src="iframeUrl"
              class="sim-iframe"
              frameborder="0"
              @load="iframeLoading = false"
            ></iframe>
          </div>
        </vs-card>

        <!-- Log Alanı -->
        <vs-card v-if="logs.length" class="mt-4">
          <div slot="header"><h3>📋 İşlem Logları</h3></div>
          <div class="sim-log">
            <div v-for="(l, i) in logs" :key="i" :class="['log-line', l.type]">
              <span class="time">[{{ l.time }}]</span> {{ l.msg }}
            </div>
          </div>
        </vs-card>
      </div>

      <!-- SAĞ: Checklist Panel -->
      <div class="vx-col w-1/3">
        <vs-card>
          <div slot="header"><h3>🔄 İşlem Adımları</h3></div>

          <!-- Step 1: Check -->
          <div :class="['checklist-item', { done: checks.validated, active: !checks.validated }]">
            <div class="check-header">
              <span class="check-icon">{{ checks.validated ? '✅' : '1️⃣' }}</span>
              <span class="check-title">Check (Doğrulama)</span>
            </div>
            <p class="check-desc">Form alanlarını doğrula</p>
            <vs-button
              v-if="!checks.validated"
              color="primary"
              type="filled"
              size="small"
              class="w-full mt-2"
              @click="doCheck"
            >✔ Check Et</vs-button>
            <p v-else class="check-ok">Tüm alanlar doğrulandı.</p>
          </div>

          <!-- Step 2: Oluştur -->
          <div :class="['checklist-item', { done: checks.created, active: checks.validated && !checks.created, disabled: !checks.validated }]">
            <div class="check-header">
              <span class="check-icon">{{ checks.created ? '✅' : '2️⃣' }}</span>
              <span class="check-title">Oluştur (Şifreleme)</span>
            </div>
            <p class="check-desc">JSON → AES şifreleme → hashData oluştur</p>
            <vs-button
              v-if="checks.validated && !checks.created"
              color="warning"
              type="filled"
              size="small"
              class="w-full mt-2"
              @click="doCreate"
            >🔐 Oluştur</vs-button>
            <p v-if="checks.created" class="check-ok">hashData oluşturuldu.</p>
          </div>

          <!-- Step 3: Test Çalıştır -->
          <div :class="['checklist-item', { done: checks.tested, active: checks.created && !checks.tested, disabled: !checks.created }]">
            <div class="check-header">
              <span class="check-icon">{{ checks.tested ? '✅' : '3️⃣' }}</span>
              <span class="check-title">Test Çalıştır</span>
            </div>
            <p class="check-desc">Simülasyon iFrame ile ödeme testi</p>
            <vs-button
              v-if="checks.created && !checks.tested"
              color="success"
              type="filled"
              size="small"
              class="w-full mt-2"
              @click="doTestRun"
            >🧪 Test Çalıştır</vs-button>
            <p v-if="checks.tested" class="check-ok">Test başarılı tamamlandı.</p>
          </div>

          <!-- Step 4: Canlıdan Çalıştır -->
          <div :class="['checklist-item', { done: checks.live, active: checks.tested && !checks.live, disabled: !checks.tested }]">
            <div class="check-header">
              <span class="check-icon">{{ checks.live ? '✅' : '4️⃣' }}</span>
              <span class="check-title">Canlıdan Çalıştır</span>
            </div>
            <p class="check-desc">Gerçek KDM servisine bağlan</p>
            <vs-button
              v-if="checks.tested && !checks.live"
              color="danger"
              type="filled"
              size="small"
              class="w-full mt-2"
              @click="doLiveRun"
            >🚀 Canlıdan Çalıştır</vs-button>
            <p v-if="checks.live" class="check-ok">Canlı işlem tamamlandı.</p>
          </div>

          <!-- Reset -->
          <vs-button
            v-if="checks.validated"
            color="dark"
            type="border"
            size="small"
            class="w-full mt-4"
            @click="resetAll"
          >🔄 Sıfırla</vs-button>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import Http from "@/services/Providers/Http";

export default {
  name: "KdmSimulation",
  data() {
    return {
      formLocked: false,
      iframeUrl: null,
      iframeLoading: false,
      hashData: null,
      logs: [],
      checks: {
        validated: false,
        created: false,
        tested: false,
        live: false,
      },
      form: {
        KisiId: "111",
        Tutar: 1355.0,
        Aciklama: "1111-SHAK1111-Eğitim ödemesi yapılmıştır.",
        ApplicationId: 1111111,
        HizmetKodu: "SHAK1111",
        KisiAdSoyad: "Ad Soyad",
        KisiTcNo: "11111111111",
        KisiMail: "kisi@example.com",
        KisiAdres: "adres bilgisi",
      },
    };
  },
  methods: {
    addLog(msg, type) {
      var time = new Date().toLocaleTimeString("tr-TR");
      this.logs.push({ time: time, msg: msg, type: type || "" });
    },

    // STEP 1: Check / Doğrulama
    doCheck() {
      this.addLog("🔍 Form doğrulaması başlatılıyor...", "info");

      var errors = [];
      if (!this.form.KisiId) errors.push("Kişi ID boş");
      if (!this.form.KisiTcNo || this.form.KisiTcNo.length < 11) errors.push("TC Kimlik No geçersiz (11 hane olmalı)");
      if (!this.form.KisiAdSoyad) errors.push("Ad Soyad boş");
      if (!this.form.KisiMail) errors.push("E-posta boş");
      if (!this.form.Tutar || this.form.Tutar <= 0) errors.push("Tutar 0'dan büyük olmalı");
      if (!this.form.HizmetKodu) errors.push("Hizmet Kodu boş");
      if (!this.form.ApplicationId) errors.push("Application ID boş");

      if (errors.length > 0) {
        errors.forEach(function(e) { this.addLog("❌ " + e, "error"); }.bind(this));
        this.$vs.notify({ title: "Doğrulama Hatası", text: errors.join(", "), color: "danger" });
        return;
      }

      this.addLog("✅ Tüm alanlar doğrulandı.", "success");
      this.addLog("📋 KişiId: " + this.form.KisiId + " | TC: " + this.form.KisiTcNo + " | Tutar: " + this.form.Tutar + " ₺", "info");
      this.checks.validated = true;
      this.formLocked = true;
    },

    // STEP 2: Oluştur / Şifreleme
    async doCreate() {
      this.addLog("📤 JSON verisi hazırlanıyor...", "info");
      this.addLog("JSON: " + JSON.stringify(this.form));

      try {
        var res = await Http.post("/api/KdmSimulation/encrypt", this.form);

        if (res.data && res.data.success) {
          this.hashData = res.data.hashData;
          this.addLog("🔐 AES-CBC-PKCS7 şifreleme başarılı.", "success");
          this.addLog("📎 hashData: " + this.hashData.substring(0, 60) + "...", "info");
          this.checks.created = true;
        } else {
          this.addLog("❌ Şifreleme hatası: " + (res.data ? res.data.error : "Bilinmeyen"), "error");
        }
      } catch (e) {
        this.addLog("❌ API bağlantı hatası: " + e.message, "error");
      }
    },

    // STEP 3: Test Çalıştır (Simülasyon iFrame)
    doTestRun() {
      this.addLog("🧪 Test modu — Simülasyon iFrame açılıyor...", "info");

      var locale = this.$i18n ? this.$i18n.locale : "tr";
      this.iframeUrl =
        process.env.VUE_APP_BASE_URL +
        locale +
        "/api/KdmSimulation/payment?hashData=" +
        encodeURIComponent(this.hashData);
      this.iframeLoading = true;
      this.addLog("🖼️ iFrame URL: " + this.iframeUrl.substring(0, 80) + "...", "info");
    },

    // STEP 4: Canlıdan Çalıştır
    doLiveRun() {
      this.addLog("🚀 Canlı mod — Gerçek KDM servisine bağlanılıyor...", "info");

      // Gerçek provider endpoint'i
      var locale = this.$i18n ? this.$i18n.locale : "tr";
      var providerUrl = process.env.VUE_APP_BASE_URL +
        locale +
        "/api/KdmPayment/initiate-payment";

      this.addLog("📡 Endpoint: " + providerUrl, "info");
      this.addLog("⚠️ Canlı KDM servisine POST gönderiliyor...", "info");

      var self = this;
      Http.post("/api/KdmPayment/initiate-payment", this.form)
        .then(function(res) {
          if (res.data && res.data.iframeUrl) {
            self.addLog("✅ KDM servisinden iFrame URL alındı.", "success");
            self.iframeUrl = res.data.iframeUrl;
            self.iframeLoading = true;
            self.checks.live = true;
          } else {
            self.addLog("⚠️ Beklenen iframeUrl bulunamadı: " + JSON.stringify(res.data), "error");
            self.checks.live = true;
          }
        })
        .catch(function(e) {
          self.addLog("❌ Canlı bağlantı hatası: " + (e.message || "Bilinmeyen"), "error");
          self.checks.live = true;
        });
    },

    // iFrame'den postMessage dinle
    handlePostMessage(event) {
      try {
        var data =
          typeof event.data === "string"
            ? JSON.parse(event.data)
            : event.data;

        if (data.type === "PAYMENT_SUCCESS") {
          this.addLog("✅ iFrame'den ödeme başarılı mesajı alındı.", "success");
          this.addLog("📡 KDM callback gönderiliyor...", "info");
          this.checks.tested = true;
          this.sendCallback();
        }
      } catch (e) {
        // Diğer mesajları yoksay
      }
    },

    async sendCallback() {
      try {
        var res = await Http.post("/api/KdmSimulation/send-callback", {
          ApplicationId: this.form.ApplicationId,
          BaseUrl: window.location.origin,
        });

        if (res.data && res.data.success) {
          this.addLog("✅ Callback başarılı! Transaction güncellendi.", "success");
        } else {
          this.addLog("⚠️ Callback yanıtı: " + JSON.stringify(res.data), "error");
        }
      } catch (e) {
        this.addLog("❌ Callback hatası: " + e.message, "error");
      }
    },

    resetAll() {
      this.formLocked = false;
      this.iframeUrl = null;
      this.iframeLoading = false;
      this.hashData = null;
      this.logs = [];
      this.checks = { validated: false, created: false, tested: false, live: false };
    },
  },
  mounted() {
    window.addEventListener("message", this.handlePostMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handlePostMessage);
  },
};
</script>

<style scoped>
.sim-desc { color: #94a3b8; margin-bottom: 16px; font-size: 13px; }

/* Checklist */
.checklist-item {
  padding: 14px;
  border-radius: 10px;
  margin-bottom: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  transition: all 0.3s;
}
.checklist-item.active {
  border-color: #3b82f6;
  background: #eff6ff;
  box-shadow: 0 2px 8px rgba(59,130,246,0.1);
}
.checklist-item.done {
  border-color: #22c55e;
  background: #f0fdf4;
}
.checklist-item.disabled {
  opacity: 0.5;
}
.check-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.check-icon { font-size: 18px; }
.check-title { font-weight: 600; color: #1e293b; font-size: 14px; }
.check-desc { font-size: 12px; color: #94a3b8; margin: 0; }
.check-ok { font-size: 12px; color: #22c55e; margin: 6px 0 0; font-weight: 600; }

/* Log */
.sim-log {
  background: #0f172a;
  border-radius: 8px;
  padding: 12px;
  max-height: 250px;
  overflow-y: auto;
  font-family: 'Consolas', monospace;
  font-size: 12px;
}
.log-line { padding: 3px 0; color: #94a3b8; }
.log-line.info { color: #38bdf8; }
.log-line.success { color: #4ade80; }
.log-line.error { color: #f87171; }
.log-line .time { color: #64748b; margin-right: 6px; }

/* iFrame */
.sim-iframe-wrapper {
  width: 100%;
  min-height: 550px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #f0f4f8;
  position: relative;
}
.sim-iframe {
  width: 100%;
  min-height: 550px;
  border: none;
}
.sim-iframe-loading {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f0f4f8;
  z-index: 1;
}
.sim-iframe-loading p {
  color: #64748b;
  font-size: 14px;
  margin-top: 8px;
}
.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e2e8f0;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
